import { bytesToNDigits } from 'lib/bytes';
import React, { ReactEventHandler, VFC } from 'react';
import { useDispatch } from 'react-redux';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { downloadArchiveItemRequest } from 'reactApp/modules/viewer/viewer.module';
import { IArchiveItem } from 'reactApp/modules/viewer/viewer.types';
import { DatalistRowItem } from 'reactApp/ui/Mobile/Datalist/DatalistRowItem/DatalistRowItem';
import { DownloadIcon } from 'reactApp/ui/VKUIIcons';

interface IItemRowProps {
    item: IArchiveItem;
    storage: EStorageType;
    archiveId: string;
    onClick: (item: IArchiveItem) => void;
}

export const ItemRow: VFC<IItemRowProps> = ({ onClick, item, storage, archiveId }) => {
    const dispatch = useDispatch();

    const canDownload = !item.isEncrypted && !item.isFolder;
    const size = (item.size && bytesToNDigits(item.size, 3).value) || '';

    const handleDownload: ReactEventHandler = (e) => {
        e.stopPropagation();
        dispatch(
            downloadArchiveItemRequest({
                storage,
                archiveId,
                itemId: item.path,
            })
        );
    };

    return (
        <DatalistRowItem
            ext={item.ext}
            id="test"
            isFolder={item.isFolder}
            size={size}
            isSelected={false}
            isSelecting={false}
            isVirus={false}
            kind={item.kind}
            name={item.nameWithoutExt || item.name}
            weblink={false}
            onClick={() => onClick(item)}
            showOptionIcon={canDownload}
            optionIconElement={<DownloadIcon />}
            onOptions={handleDownload}
        />
    );
};
